import graphqlApi from '../api/graphqlApi';
import {
    getShopifyCustomer,
    getShopifyCustomerAccessToken,
} from './queries/shopifyCustomer';
import { CartResponse } from '../../models/Cart';
import useSWR from 'swr';
import { retrieveShopifyCart } from './queries/shopifyCart';
import { ShopifyCustomerResponse } from '../../models/ShopifyCustomerResponse';

const useShopifyCustomer = () => {
    const getCustomerAccessTokenWithMultipass = (
        multipassToken
    ): Promise<any> => {
        return graphqlApi
            .post(getShopifyCustomerAccessToken(), {
                multipassToken: multipassToken,
            })
            .then((res) => {
                return res.customerAccessTokenCreateWithMultipass;
            })
            .catch((error) => {
                throw error;
            });
    };

    const getCustomerSWR = (token) => {
        const fetchCustomer = (query): Promise<ShopifyCustomerResponse> => {
            return graphqlApi
                .post(query, {
                    customerAccessToken: token,
                })
                .then((res) => {
                    return res.customer;
                })
                .catch((error) => {
                    throw error;
                });
        };

        const { data, error, isLoading, mutate, isValidating } = useSWR(
            getShopifyCustomer(),
            fetchCustomer,
            {
                dedupingInterval: 600000, // 10min
                errorRetryCount: 3,
            }
        );

        return {
            customer: data ? data : null,
            isLoading: isLoading,
            isError: error,
            forceRefresh: mutate,
            isValidating: isValidating,
        };

    };

    return { getCustomerAccessTokenWithMultipass, getCustomerSWR };
};

export default useShopifyCustomer;
